import { render, staticRenderFns } from "./PurchaseOrderReceivedItemsTable.vue?vue&type=template&id=bc9cefce&scoped=true&"
import script from "./PurchaseOrderReceivedItemsTable.vue?vue&type=script&lang=ts&"
export * from "./PurchaseOrderReceivedItemsTable.vue?vue&type=script&lang=ts&"
import style0 from "./PurchaseOrderReceivedItemsTable.vue?vue&type=style&index=0&id=bc9cefce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc9cefce",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VDataTable,VTextField})
